import { CellType } from './cell'
import {
  millisecondsToMinutes,
} from 'common/utils/time'

export const transferCellFromTicketsHop = (response, hopIndex) => {
  if (!response.hops[hopIndex].isTransfer) {
    throw Error(
      'Can\'t create a TransferCell from a hop not marked transfer. hop.isTransfer === false'
    )
  }

  const transfer = response.hops[hopIndex]
  const durationInMinutes = transfer.duration
  const vehicle = response.vehicles[transfer.vehicle]
  const carrier = transfer.marketingCarrier != null
    ? response.carriers[transfer.marketingCarrier]
    : null

  let iconUrl = null
  if (carrier && carrier.iconUrl) {
    // This check is needed to ensure icons work when the product is run locally.
    // When local, the url has the form "[PATH]" and be unaltered.
    // When not local, the url has the form "//[HOST][PATH]" and should be prepended with "https"
    if (carrier.iconUrl.indexOf('//') === 0) {
      iconUrl = `https:${carrier.iconUrl}`
    } else {
      iconUrl = carrier.iconUrl
    }
  }

  const line = response.lines[transfer.line]
  const fromPlaceIndex = line.places[0]
  const fromPlace = response.places[fromPlaceIndex]
  const toPlaceIndex = line.places[line.places.length - 1]
  const toPlace = response.places[toPlaceIndex]

  return {
    type: CellType.Transfer,
    fromPlace: fromPlace.name,
    toPlace: toPlace.name,
    durationInMinutes,
    ...(iconUrl) && { iconUrl },
    ...(vehicle) && { vehicle },
    ...(carrier) && { carrier: carrier.name },
  }
}

export const transferCellFromCheckoutHop = (hop, operator) => {
  if (!hop.isTransfer) {
    throw Error(
      'Can\'t create a TransferCell from a hop not marked transfer. hop.isTransfer === false'
    )
  }

  const fromPlace = hop.origin
  const toPlace = hop.destination
  const durationInMinutes = millisecondsToMinutes(hop.duration)

  const vehicle = hop.equipment
  const carrier = operator.name
  let iconUrl = null
  if (operator && operator.logo) {
    // This check is needed to ensure icons work when the product is run locally.
    // When local, the url has the form "[PATH]" and be unaltered.
    // When not local, the url has the form "//[HOST][PATH]" and should be prepended with "https"
    const logo = operator.logo
    if (logo.indexOf('//') === 0) {
      iconUrl = `https:${logo}`
    } else {
      iconUrl = logo
    }
  }

  return {
    type: CellType.Transfer,
    fromPlace,
    toPlace,
    durationInMinutes,
    ...(iconUrl) && { iconUrl },
    ...(vehicle) && { vehicle },
    ...(carrier) && { carrier },
  }
}
